import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ROUTE_PERMISSIONS = {
  "/manageLeads": {
    moduleName: "Manage Leads",
    permissionType: "view",
  },
  "/manageUsers": {
    moduleName: "Manage Users",
    permissionType: "view",
  },
  "/reports": {
    moduleName: "Reports V1",
    permissionType: "view",
  },
  "/user-permissions": {
    requiresAdmin: true,
  },
  "/psmautomation": {
    moduleName: "Automate Templates",
    permissionType: "view",
  },
  "/wtemplates": {
    moduleName: "Automate Templates",
    permissionType: "view",
  },
  "/churnautomation": {
    moduleName: "Automate Templates",
    permissionType: "view",
  },
};

const ProtectedRoute = ({ children }) => {
  const { pathname } = useLocation();
  const user = useSelector((state) => state.user.userDetails);

  // Early return if no user data
  if (!user?.UserDetails?.email) {
    return <Navigate to="/login" replace />;
  }

  const userPermissions = user.useraccess || [];
  const isAdmin = user.UserDetails.role === "Administrator";

  // Check permissions for current route
  const routeConfig = ROUTE_PERMISSIONS[pathname];
  if (routeConfig) {
    if (routeConfig.requiresAdmin && !isAdmin) {
      return <Navigate to="/" replace />;
    }

    if (routeConfig.moduleName) {
      const modulePermission = userPermissions.find(
        (perm) => perm.modulename === routeConfig.moduleName
      );

      if (!modulePermission?.[routeConfig.permissionType]) {
        return <Navigate to="/" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;
